import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import FormLayout from './FormLayout'
import ButtonActionsContext from '@/utils/contexts/form-layout/ButtonActionsContext'
import { useMemo, useState } from 'react'
import { IButtonActionsType } from '@/types/FormLayout'
import FormStepper from './FormStepper'
import { FormStepperData } from '@/data/merchant-register-forms/FormStepperData'

const SellerFormLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const currentStep =
    FormStepperData.find((step) => location.pathname.includes(step.url)) ||
    FormStepperData[0]

  const [buttonActions, setButtonActions] = useState<IButtonActionsType>({
    nextStepDisabled: true,
    prevStepDisabled: true,
    nextStepAction: () => {},
    prevStepAction: () => navigate(-1),
    nextStepIsLoading: false,
    prevStepIsLoading: false
  })

  const contextValue = useMemo(
    () => ({ buttonActions, setButtonActions }),
    [buttonActions, setButtonActions]
  )

  return (
    <FormLayout>
      <FormLayout.Header className="flex justify-center items-center">
        <FormStepper currentStep={currentStep} />
      </FormLayout.Header>
      <ButtonActionsContext.Provider value={contextValue}>
        <FormLayout.Main>
          <Outlet />
        </FormLayout.Main>
      </ButtonActionsContext.Provider>
    </FormLayout>
  )
}

export default SellerFormLayout
